import { z } from 'zod'

import { StringDtoSchema } from '@hcr/api/shared'

import { BenefitsGroupDtoSchema } from '../components'

export const BenefitsDtoSchema = z.strictObject({
  content: z.array(BenefitsGroupDtoSchema),
  description: StringDtoSchema,
  imageUrl: StringDtoSchema.url(),
  title: StringDtoSchema,
})

export type BenefitsDto = z.infer<typeof BenefitsDtoSchema>

export const isBenefitsDto = (x: unknown): x is BenefitsDto => BenefitsDtoSchema.safeParse(x).success
